import { FormEvent, useState } from "react";
import { api } from "../api";

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [showSignup, setShowSignup] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post("/api/auth/login", { username, password });
      onLogin();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-screen grid place-items-center">
      <div className="w-80 space-y-3">
        <form onSubmit={submit} className="card space-y-4">
          <div>
            <div className="text-2xl font-black tracking-tight uppercase">Stonky</div>
            <div className="text-[10px] font-mono tracking-[0.2em] text-slate-500 uppercase">
              Ruthless · Disciplined · Flat by close
            </div>
          </div>
          <div>
            <label className="label">Username</label>
            <input className="input" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
          </div>
          <div>
            <label className="label">Password</label>
            <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <div className="text-down text-xs">{error}</div>}
          <button className="btn btn-primary w-full" disabled={busy || !username || !password}>
            {busy ? "…" : "Sign in"}
          </button>
        </form>
        {!showSignup ? (
          <button className="text-xs text-slate-500 hover:text-accent w-full text-center"
                  onClick={() => setShowSignup(true)}>
            Not a client? Get the Bull Sheet by email →
          </button>
        ) : (
          <SubscribeForm onDone={() => setShowSignup(false)} />
        )}
      </div>
    </div>
  );
}

function SubscribeForm({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [daily, setDaily] = useState(true);
  const [website, setWebsite] = useState(""); // honeypot — real users never see this
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post("/api/public/subscribe", {
        email, first_name: firstName || undefined, daily_opt_in: daily, website: website || undefined,
      });
      setDone(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="card text-sm text-center space-y-2">
        <div className="text-up">Check your email — your link is on the way.</div>
        <button className="text-xs text-slate-500 hover:text-accent" onClick={onDone}>back to sign in</button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="card space-y-3">
      <div className="text-sm font-semibold">Get the Bull Sheet by email</div>
      <input className="input" placeholder="First name (optional)"
             value={firstName} onChange={(e) => setFirstName(e.target.value)} />
      <input className="input" type="email" placeholder="Email" required
             value={email} onChange={(e) => setEmail(e.target.value)} />
      <input type="text" tabIndex={-1} autoComplete="off" value={website}
             onChange={(e) => setWebsite(e.target.value)}
             className="absolute opacity-0 pointer-events-none -z-10" aria-hidden="true" />
      <label className="flex items-center gap-2 text-xs text-slate-400">
        <input type="checkbox" checked={daily} onChange={(e) => setDaily(e.target.checked)} />
        Send me the daily edition
      </label>
      {error && <div className="text-down text-xs">{error}</div>}
      <div className="flex gap-2">
        <button type="button" className="btn text-xs" onClick={onDone}>cancel</button>
        <button className="btn btn-primary text-xs flex-1" disabled={busy || !email}>
          {busy ? "…" : "Get my link"}
        </button>
      </div>
    </form>
  );
}
